import React from 'react';
import { RemoteComponent } from '@nike/remote-component';

/**
 * Nike AI Search Remote Component
 * Loads the nike-ai-search fragment via RemoteComponent
 * Controlled via window.webShellClient.__WS_INTERNAL__.nikeAI
 *
 * Endpoint can be overridden via NIKE_AI_SEARCH_ENDPOINT env var
 * Falls back to production CDN endpoint
 */
const NikeAISearch = () => {
  // Check for environment variable override, fallback to production CDN
  const endpoint =
    typeof window !== 'undefined' && window.NAV_INITIAL_DATA?.nikeAIEndpoint
      ? window.NAV_INITIAL_DATA.nikeAIEndpoint
      : 'https://www.nike.com/fragments/nike-ai-search';

  return <RemoteComponent endpoint={endpoint} ssr={false} />;
};

NikeAISearch.displayName = 'NikeAISearch';

export default NikeAISearch;
